<template>
  <div class="footer">
    <footer id="footer">
      <div class="inner">
    <!--     <div class="header">
          <section>
            <h3>EMPREINTE</h3>
            <p>EMPREINTE.COM diffuse une gamme complète de solution vidéo :
              LIVE, RICHMEDIA, WEBTV, INTRANET, DISPLAY.
              EMPREINTE.COM maîtrise l’ensemble du cycle de la communication digitale.</p>
          </section>
        </div>
        <div class="content">
          <section>
            <h4>Solutions</h4>
            <ul class="alt">
              <li><a href="#">Web TV</a></li>
              <li><a href="#">Live</a></li>
              <li><a href="#">RichMedia</a></li>
              <li><a href="#">Display</a></li>
              <li><a href="#">Intranet</a></li>
              <li><a href="#">Conférence</a></li>
            </ul>
          </section>
          <section>
            <h4>Services</h4>
            <ul class="alt">
              <li><a href="#">Webcast</a></li>
              <li><a href="#">Production</a></li>
              <li><a href="#">Hébergement</a></li>
              <li><a href="#">Etude, conseil</a></li>
              <li><a href="#">Ingénierie</a></li>
              <li><a href="#">Support</a></li>
            </ul>
          </section>
          <section>
            <ul class="plain">
              <li><a href="https://twitter.com/empreinte_com"><i class="icon fa-twitter">&nbsp;</i>Twitter</a></li>
              <li><a href="https://www.linkedin.com/in/empreinte-multimedia-70909931"><i class="icon fa-linkedin">&nbsp;</i>Linkedin</a></li>
            </ul>
          </section>
        </div> -->
        <div class="copyright">
          &copy;
          <a href="//www.empreinte.com/" target="_blank">{{ new Date().getFullYear() }} Empreinte.com</a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  export default {
    name: 'footer-fo'}
</script>



// WEBPACK FOOTER //
// Footer.vue?b277e314